import type { FC, KeyboardEvent, ReactNode } from 'react';
import { Picture } from '@ui';
import {
  questionTooltip,
  orderRegisterHover,
  orderRegisterUnchecked,
  orderRegisterChecked
} from '@images';

interface AddressCheckboxProps {
  checked: boolean;
  onChange: () => void;
  label: ReactNode;
  /**
   * Hover icon — defaults to the generic hover sprite. The mapped-checkbox
   * variant in the original code swaps it for the checked icon when active,
   * so callers can override.
   */
  iconHover?: any;
  description?: string | null;
  className?: string;
}

const AddressCheckbox: FC<AddressCheckboxProps> = ({
  checked,
  onChange,
  label,
  iconHover = orderRegisterHover.x3,
  description,
  className = 'checkbox'
}) => {
  const handleKey = (e: KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      onChange();
    }
  };

  return (
    <div
      className={className}
      role='button'
      tabIndex={0}
      aria-pressed={checked}
      onKeyDown={handleKey}
    >
      <Picture
        icon={checked ? orderRegisterChecked.x3 : orderRegisterUnchecked.x3}
        iconHover={iconHover}
        height='20'
        className={checked ? 'icon checked-icon' : 'icon unchecked-icon'}
        onClick={onChange}
      />
      <span onClick={onChange}>{label}</span>
      {description ? (
        <div className='is-tooltip'>
          <Picture icon={questionTooltip} height='20' className='helper-info' />
          <span className='tooltip'>
            <span className='text'>{description}</span>
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default AddressCheckbox;
